import React from 'react';
import Table from '../../../common/components/Table';
import PropTypes from 'prop-types';


const disabledStyle = {
  opacity: 0.6,
  cursor: 'not-allowed',
};

const userTableRow = (onItemRemove, onItemEdit, isItemRemovalEnabled = (item) => true, t) => {


  const handleItemRemoval = (item)=>{
    if ( !isItemRemovalEnabled(item) ) {
      return;
    }

    onItemRemove(item);
  };

  return (row) => (
    <tr key={row.uuid}>
      <td>{row.name}</td>
      <td>{row.email}</td>
      <td>{row.username}</td>
      <td>{row.roles.map(role => t('roles.' + role)).join(' ')}</td>
      <td>{t('common:boolean.' + row.enabled)}</td>
      <td>
        <a onClick={() => onItemEdit(row)} className="badge rounded-pill fs-6 bg-primary"><i className="fas fa-pencil-alt"></i></a>
      </td>
      <td>
        <span className="badge rounded-pill fs-6 bg-primary pill-button" onClick={() => handleItemRemoval(row)} style={isItemRemovalEnabled(row) ? {} : disabledStyle}><i className="far fa-trash-alt"></i></span>
      </td>
    </tr>
  );
};

const UserTable = ({ t, data, onItemRemove, onItemEdit, isItemRemovalEnabled }) => {

  const columnTitles = [
    "user.name",
    "user.email",
    "user.username",
    "user.roles",
    "user.active",
    '',
    '',
  ].map(key => t(key));

  return (
    <Table columnTitles={columnTitles} rows={data} renderRow={userTableRow(onItemRemove, onItemEdit, isItemRemovalEnabled, t)} />
  );
};

UserTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onDelete: PropTypes.func,
};

export default UserTable;
